import Vue from 'vue'

export default {
  endpoint: 'cmsping',
  async get () {
    try {
      await Vue.http.get(this.endpoint)
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  },
}



// WEBPACK FOOTER //
// ./src/application/cmsping.js